<template>
    <div class="ChangeDepartment">
        <Box title="申请转科">
            <FacilityDetails :data="{
            Images: require('@/assets/img/Icon_1.png'),
            EquName: data.SBMC,
            EquCode: data.SBBH,
            Size: data.SBXH,
            EquNumber: data.SBXLH,
            DepartmentName: data.SYKSMC,
            deadline: data.deadline
        }" :hidden-department="true"/>
            <div class="infoBox">
                <p class="title">转科信息</p>
                <Field title="转科日期" type="text" :text='time'/>
               <Field title="原科室" class="ellipsis" :text='data.SYKSMC' type='text'/>

               <Field title="原科室负责人" class="ellipsis" placeholder='请选择' :text='data.DirectorName||data.OldKSFZRMC' type='manufacturer' name='personnel'
			   @manuconfirm="data.DirectorName=arguments[0].a,data.OldKSFZR=arguments[0].a,data.OldKSFZRMC=arguments[0].b"/>

               <Field title="新科室" :action="true" class="ellipsis" placeholder="请选择" type='manufacturer' name="departmentList"
               @manuconfirm="DepartmentNewId=arguments[0].a,newPrincipalText=arguments[0].X,newPrincipal=arguments[0].f;" />

                <Field title="新负责人" placeholder="请选择"  :text="newPrincipalText" type='manufacturer' name="personnel"
                @manuconfirm="newPrincipal=arguments[0].a,newPrincipalText=arguments[0].b" />

                <Field title="转科文号" placeholder="请输入" maxlength='10' @onMessage="value => referenceNumber = value" />
                <Field title="存放地点" class="ellipsis" placeholder="请选择" type='manufacturer' name="departmentList"
                @manuconfirm="address=arguments[0].a" />
                <Field title="转科原因" :action="true" placeholder="请输入转科原因" type="textarea"
                       @onMessage="value => reason = value"
                />
            </div>
        </Box>
        <Footer button="申请转科" @change="upload"/>
    </div>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    import Bus from "../../components/bus/bus";
    import ImgModule from '../../components/imgModule/imgModule'

    export default {
        name: 'ChangeDepartment',
        data() {
            return {
                KSFZR:null,
                data: this.$route.params.item,
                action: null,
                time: this.$format(new Date(),'YYYY-MM-DD'),             //  转科时间
                newPrincipal: null,     //  新负责人
                referenceNumber: null,  //  转科文号
                DepartmentNewId:null,   //新科室编号
                address: null,          //  存放地址
                reason: null,           //  转科原因
                newPrincipalText:'',//新科室负责人显示值
            }
        },
        components: {
            Box,
            FacilityDetails,
            Footer,
            Field,
            ImgModule
        },
        mounted() {},
        methods: {
            upload() {
                const data={
                    Store:this.$UserInfo.StoreCode,//当前仓库
                    UserCode:this.data.DirectorName,//原科室负责人
                    EquId:this.data.SBBH,//转科资产
                    DepartmentId:this.data.SYKS,//目前科室
                    DepartmentNewId:this.DepartmentNewId,//转科科室
                    DepUserCode:this.newPrincipal,//新科室负责人
                    TextNumber:this.referenceNumber,//转科文号
                    ZKDate:this.time,//转科日期
                    Reason:this.reason,//转科原因
                    SavePlace:this.address,//存放地点
                    Applicant:this.$UserInfo.UserId,
                };
                if(!this.$verification(data,[{id:'DepartmentNewId',name:'转科新科室不能为空，请选择!'},{id:'Reason',name:'请输入转科原因!'}])){
                    return false;
                }

                if(String.trim(data.DepartmentId)==String.trim(data.DepartmentNewId)){
                    this.$Toast('新科室与原科室相同,相同科室不能申请转科!');
                    return false;
                }

                this.$post('api/ZK/ZK',data).then(result=>{
                     if(result.Status){
                         this.$Toast({
                             message:'申请转科成功!',
                             duration:1500,
                             onClose:x=>{
                                 this.$router.go(-1);
                             }
                         });
                     }else this.$Toast(result.Msg);
                 })

            }
        }
    }
</script>

<style scoped lang="scss">
    .ChangeDepartment {
        padding-bottom: 112px;
    }
</style>



// WEBPACK FOOTER //
// src/page/changeDepartment/changeDepartment.vue